module.exports = __webpack_public_path__ + "img/questionnaire-start.9f62744f.png";